/**
 * Created by mike on 11/12/15.
 */
(function() {

    //Dropdown Toggle
    toggleDropdown = function(e){
        var dropdownParent = angular.element(e.currentTarget).parent();
        if (dropdownParent.hasClass('open')) {
            dropdownParent.removeClass('open');
    
        } else {
            dropdownParent.addClass('open')
        }
    };

    decodeBase64 = function (s) {
        var e = {}, i, b = 0, c, x, l = 0, a, r = '', w = String.fromCharCode, L = s.length;
        var A = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        for (i = 0; i < 64; i++) {
            e[A.charAt(i)] = i;
        }
        for (x = 0; x < L; x++) {
            c = e[s.charAt(x)];
            b = (b << 6) + c;
            l += 6;
            while (l >= 8) {
                ((a = (b >>> (l -= 8)) & 0xff) || (x < (L - 2))) && (r += w(a));
            }
        }
        return r;
    };

    typeOf = function(obj) {
        return {}.toString.call(obj).split(' ')[1].slice(0, -1).toLowerCase();
    };

    newObject = function($key,$value){
        var $o = {};
        $o[$key]=$value;
        return $o;
    };

    newFormObject = function ($key, $value) {
        var $o = {};
        $o['name'] = $key;
        $o['value'] = $value;
        return $o;
    };


    newSelectObject = function ($key, $value,$multi) {
        var $o = newFormObject($key,$value);
        $o['type']=$multi;
        return $o;
    };

    ucWords = function(str) {
        return (str + '')
            .replace(/^([a-z\u00E0-\u00FC])|\s+([a-z\u00E0-\u00FC])/g, function ($1) {
                return $1.toUpperCase();
            });
    };

    findByName = function(array,key){

        if(array !== undefined) {
            for (var i = 0; i < array.length; i++) {
                if (array[i].name == key) {
                    return array[i].value;
                }
            }
        }

        return undefined;
    };


    findImageRuleByName = function(rfModel, name){

        if(rfModel !== undefined) {
            return rfModel.data[name].rules;
        }

        return undefined;
    };

    findIndexByDemographicText = function(array,text){

        if(array !== undefined) {
            for (var i = 0; i < array.length; i++) {
                if (array[i].text == text) {
                    return i;
                }
            }
        }

        return undefined;
    };

    findSelectedOption = function(array){
        if(array != undefined){
            for(var i =0; i<array.length; i++){
                if(array[i].option.selected == true ){
                    return array[i];
                }
            }
        }

        return undefined;
    };

    parseQueryObject = function(group) {

        var queryObjectArray = [];

        function queryObject() {
            this.inc_exc = '';
            this.pulse = '';
            this.question = '';
            this.answerString = '';
            this.answers = [];
        }

        if(typeof group.option.query_object !== 'undefined') {

            for(var i = 0; i < group.option.query_object.length; i++) {

                if(group.option.query_object[i].field === 'pulses') {

                    var tempQO = new queryObject();

                    tempQO.pulse = group.option.query_object[i].text;
                    tempQO.inc_exc = group.option.query_object[i].inc_exc;

                    if(typeof group.option.query_object[i + 1] !== 'undefined') {

                        if (group.option.query_object[i + 1].field !== 'questions') {

                            queryObjectArray.push(tempQO);
                        }
                    } else {

                        queryObjectArray.push(tempQO);
                    }
                }

                if(group.option.query_object[i].field === 'questions') {

                    tempQO.question = group.option.query_object[i].text;

                    if(typeof group.option.query_object[i + 1] !== 'undefined') {

                        if(group.option.query_object[i + 1].field !== 'answers') {

                            queryObjectArray.push(tempQO);
                        }
                    } else {

                        queryObjectArray.push(tempQO);
                    }
                }

                if(group.option.query_object[i].field === 'answers') {

                    tempQO.answers.push(group.option.query_object[i].text);

                    var connector = ', ';
                    tempQO.answerString += (tempQO.answerString === '' ? '' : connector) + group.option.query_object[i].text;

                    if(typeof group.option.query_object[i + 1] !== 'undefined') {

                        if (group.option.query_object[i + 1].field === 'pulses') {

                            queryObjectArray.push(tempQO);
                        }
                    } else {

                        queryObjectArray.push(tempQO);
                    }
                }
            }
        }

        return queryObjectArray;
    };

    findKeyById = function(array,id){

        if(array !== undefined) {
            for (var i = 0; i < array.length; i++) {
                if (array[i].data.id.value == id) {
                    return i;
                }
            }
        }

        return undefined;
    };

    findItemById = function(array,id){

        if(array !== undefined) {
            for (var i = 0; i < array.length; i++) {
                if (array[i].data.id.value == id) {
                    return array[i];
                }
            }
        }

        return undefined;
    };

    findOptionByToken = function(array,id){

        if(array !== undefined) {
            for (var i = 0; i < array.length; i++) {
                if (array[i].option_token == id) {
                    return array[i];
                }
            }
        }

        return undefined;
    };

    unsetElementByDataToken = function(array, token) {

        if(array !== undefined) {

            for (var key in array) {

                if (array[key].data_token == token) {

                    array.splice(key, 1);
                }
            }
        }

        return array;
    };

    removeCharsAfterChar = function(char, string) {

        var n = string.indexOf(char);

        return string.substring(0, n != -1 ? n : string.length);
    };

    findOptionIndexByToken = function(array,id){

        if(array !== undefined) {
            for (var i = 0; i < array.length; i++) {
                if (array[i].option_token == id) {
                    return i;
                }
            }
        }

        return undefined;
    };

    findOptionById = function(array,id){

        if(array !== undefined) {
            for (var i = 0; i < array.length; i++) {
                if (array[i].option.id == id) {
                    return array[i];
                }
            }
        }

        return undefined;
    };

    findOptionKeyById = function(array,id){
        key = false;
        if(array !== undefined) {
            for (var i = 0; i < array.length; i++) {
                if (array[i].option.id == id) {
                    key = i;
                }
            }
        }

        return key;
    };

    findDataById = function(array,id){

        if(array !== undefined) {
            for (var i = 0; i < array.length; i++) {
                if (array[i].data.id.value == id) {
                    return array[i].data;
                }
            }
        }

        return undefined;
    };

    findTokenById = function(array,id){

        if(array !== undefined) {
            for (var i = 0; i < array.length; i++) {
                if (array[i].data.id.value == id) {
                    return array[i].data_token;
                }
            }
        }

        return undefined;
    };

    filterPulses = function(array,status){

        var response = [];
        
        if(array != undefined){
            for(var i =0;i<array.length;i++){
                if(array[i].data.status != undefined) {
                    if (array[i].data.status.value == status) {
                        response.push(array[i]);
                    }
                }
            }
        }

        return response;
    };

    parseTextRules = function(rules){
        //TODO: if contains numeric rule then need to replace with ng-pattern="/(0|[1-9][0-9]*)/"
        return rules.replace(new RegExp('mandatory', 'g'),'ng-required:true').replace(new RegExp('min','g'),'ng-minlength').replace(new RegExp('max','g'),'ng-maxlength').split('|'); //.replace(new RegExp("[|,]",'g'),' ').
    };

    parseSelectRules = function(rules){

        string = "";
        angular.forEach(rules.split('|'),function(v){

            bits = v.split(':')

            if(bits[0]=='min'){

                if(bits[1]>0){
                    string+='ng-required:true|'
                }

                string+='op-min:'+bits[1]+'|'

            }else if(bits[0]=='max'){

                if(bits[1]>1){
                    string+='multiple:multiple|';
                }
                string+='op-max:'+bits[1]

            }
        });

        return string.split('|')
    };

    parseEndPoint = function(url){

        //split up the url
        var bits = url.split('/');

        if(bits.indexOf("api") != -1) {

            //find api and endpoint is at the next index
            var index = bits.indexOf("api")+1; //incrementing to get next

            return bits[index];
        } else {

            return "";
        }
    };

    endsWith = function(str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    };

    uppercaseFirst = function (string) {
        return typeof string != "undefined" ? string.charAt(0).toUpperCase() + string.slice(1) : "";
    };

    camelLettersUppercase = function (string) {
        if(typeof string != 'undefined' && string != null) {

            var matches = string.match(/\b(\w)/g);              // ['J','S','O','N']
            var acronym = matches.join('');                  // JSON

            return acronym.substring(0, 5).toUpperCase();
        }
    };

    imageString = function (image){
        return 'data:' + image.filetype + ';base64,' + image.base64;
    };

    stringifyDemographics = function(demographics){

        var demographicString = '';
        for(var i = 0; i < demographics.length; i++) {
            var subLoop = false;
            for(var j = 0; j < demographics[i].values.options.length; j++) {
                if(demographics[i].values.options[j].option.selected==true){
                    if(subLoop==false){
                        if(demographicString.length > 0){
                            demographicString += '; '
                        }
                        demographicString += demographics[i].text + ': ' + demographics[i].values.options[j].option.text;
                        subLoop=true;
                    }else{
                        demographicString += ', ' + demographics[i].values.options[j].option.text
                    }
                }
            }
        }

        return demographicString;
    };

    copyGroup = function(newGroup, oldGroup) {

        for(var i = 0; i < oldGroup.options.length; i++) {

            newGroup.options[i].option.selected = oldGroup.options[i].option.selected
        }

        return newGroup;
    };

    copyDemographics = function(newDemographics, oldDemographics) {

        for(var i = 0; i < oldDemographics.length; i++) {

            for(var j = 0; j < oldDemographics[i].values.options.length; j++) {

                newDemographics[i].values.options[j].option.selected = oldDemographics[i].values.options[j].option.selected;
            }
        }

        return newDemographics;
    };

    //Convert integer into ranking text
    integerToRanking = function(integer) {

        switch(integer) {

            case 1:
                return "first";
            case 2:
                return "second";
            case 3:
                return "third";
            case 4:
                return "fourth";
            case 5:
                return "fifth";
            case 6:
                return "sixth";
        }

        return "";
    };

    slug = function( str )
    {
        str = str.toLowerCase();
        str = str.replace(/[^a-z0-9]+/g, '-');
        str = str.replace(/^-|-$/g, '');
        return str;
    };

    /**
     * Generates a random string
     *
     * @param int length_
     * @return string
     */
    randomString = function(length_) {

        var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz'.split('');
        if (typeof length_ !== "number") {
            length_ = Math.floor(Math.random() * chars.length_);
        }
        var str = '';
        for (var i = 0; i < length_; i++) {
            str += chars[Math.floor(Math.random() * chars.length)];
        }
        return str;
    };

    scrollTo = function(elementId, offset){

        try {
            $('html, body').animate({
                scrollTop: $("#" + elementId).offset().top - offset
            }, 1000);
        } catch(e) {}
    };

    tempQuestion = function(){
        return null;//{"data":{"id":{"value":"MRrLOw8PL2lQ","rules":"locked"},"intro":{"value":"","rules":"mandatory|min:1|max:100"},"text":{"value":"","rules":"mandatory|min:1|max:100|translate"},"sequence":{"value":"","rules":"mandatory|numeric|min:1|max:3|in_sequence"},"link_url":{"value":"","rules":"url"},"link_type":{"options":[{"option":{"text":"video","selected":false},"option_token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJ1c2VyOmJjOTIzZGRmYTQ6b3B0aW9uIiwic3ViIjoiYXBpXC9xdWVzdGlvbiIsImlzcyI6Imh0dHBzOlwvXC9iZXRhLWFwaS5vbmVwdWxzZS5jb21cL2FwaVwvcHVsc2VcL3F1ZXN0aW9uXC9jcmVhdGUiLCJpYXQiOjE0NjA2Mjk1ODksImV4cCI6MTQ2MTgzOTMwOSwibmJmIjoxNDYwNjI5NTg5LCJqdGkiOiI3NGVkMGY0MmE0OWU2YWE2ZjA3MWJjY2RlYmVlOGM5ZSIsInJuZCI6MjA3NDc1LCJjaGsiOjYxODY1OTQ5Nn0.r91DfyY5ATcF6XlLKbtzvjjhgz6cpzh-sCjACaf3z78"},{"option":{"text":"page","selected":false},"option_token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJ1c2VyOmJjOTIzZGRmYTQ6b3B0aW9uIiwic3ViIjoiYXBpXC9xdWVzdGlvbiIsImlzcyI6Imh0dHBzOlwvXC9iZXRhLWFwaS5vbmVwdWxzZS5jb21cL2FwaVwvcHVsc2VcL3F1ZXN0aW9uXC9jcmVhdGUiLCJpYXQiOjE0NjA2Mjk1ODksImV4cCI6MTQ2MTgzOTMwOSwibmJmIjoxNDYwNjI5NTg5LCJqdGkiOiI3NGVkMGY0MmE0OWU2YWE2ZjA3MWJjY2RlYmVlOGM5ZSIsInJuZCI6Nzc0Mjg1LCJjaGsiOjE4NjcyNzIxMDZ9.RkQhEWV5XAdFVZ92h6QD-e_rZDH3_ncjTFDUAiP9evo"}],"rules":"min:1|max:1"},"image":{"value":"https://beta-api.onepulse.com/api/image/eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOnsicm9sZSI6WyJpbWFnZSoiXX0sInN1YiI6ImFwaVwvaW1hZ2UiLCJpc3MiOiJodHRwczpcL1wvYmV0YS1hcGkub25lcHVsc2UuY29tXC9hcGlcL3B1bHNlXC9jcmVhdGUiLCJpYXQiOjE0NjA2MjU0NTIsImV4cCI6MTQ2MTgzNTE3MiwibmJmIjoxNDYwNjI1NDUyLCJqdGkiOiI4OWEzZTY5NDcwMmNjNDNjMjVkMTIwNTE3MGVlMzAwNyIsInJuZCI6MzM3NTA3LCJjaGsiOjE4NjcyNzIxMDZ9.HZyn3JlQsXQ2aOOqtR43-VKcCkq0_qeQdV2CoTw92nI","rules":"image_path:8,555,366"},"is_allow_comment":{"value":"0","rules":"boolean"},"format":{"options":[{"option":{"text":"Exclusive","selected":true},"option_token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJ1c2VyOjU5OThhYjE1MGM6b3B0aW9uIiwic3ViIjoiYXBpXC9xdWVzdGlvbiIsImlzcyI6Imh0dHBzOlwvXC9iZXRhLWFwaS5vbmVwdWxzZS5jb21cL2FwaVwvcHVsc2VcL3F1ZXN0aW9uXC9jcmVhdGUiLCJpYXQiOjE0NjA2Mjk1ODksImV4cCI6MTQ2MTgzOTMwOSwibmJmIjoxNDYwNjI5NTg5LCJqdGkiOiI3NGVkMGY0MmE0OWU2YWE2ZjA3MWJjY2RlYmVlOGM5ZSIsInJuZCI6NzE4NDYxLCJjaGsiOjIxNTMwNDcyNH0.q7cvX5-J1UhCNCTimM1sp4hbv2pOcf_w0YOFlkKMs_A"},{"option":{"text":"Multiple","selected":false},"option_token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJ1c2VyOjU5OThhYjE1MGM6b3B0aW9uIiwic3ViIjoiYXBpXC9xdWVzdGlvbiIsImlzcyI6Imh0dHBzOlwvXC9iZXRhLWFwaS5vbmVwdWxzZS5jb21cL2FwaVwvcHVsc2VcL3F1ZXN0aW9uXC9jcmVhdGUiLCJpYXQiOjE0NjA2Mjk1ODksImV4cCI6MTQ2MTgzOTMwOSwibmJmIjoxNDYwNjI5NTg5LCJqdGkiOiI3NGVkMGY0MmE0OWU2YWE2ZjA3MWJjY2RlYmVlOGM5ZSIsInJuZCI6MjYwNjU4LCJjaGsiOjQyNjM0NzMyODZ9.lpGFrAQnq9suoqClflFLhL0ZePX2tunZLKaiPoOK-Ac"},{"option":{"text":"Slider","selected":false},"option_token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJ1c2VyOjU5OThhYjE1MGM6b3B0aW9uIiwic3ViIjoiYXBpXC9xdWVzdGlvbiIsImlzcyI6Imh0dHBzOlwvXC9iZXRhLWFwaS5vbmVwdWxzZS5jb21cL2FwaVwvcHVsc2VcL3F1ZXN0aW9uXC9jcmVhdGUiLCJpYXQiOjE0NjA2Mjk1ODksImV4cCI6MTQ2MTgzOTMwOSwibmJmIjoxNDYwNjI5NTg5LCJqdGkiOiI3NGVkMGY0MmE0OWU2YWE2ZjA3MWJjY2RlYmVlOGM5ZSIsInJuZCI6NDkyOTM3LCJjaGsiOjE1ODEzODk0MjR9.ObBhOpolGYeWOhWynLC6tCOeji518RHTfi5h6omjCPs"},{"option":{"text":"Drag & Drop","selected":false},"option_token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJ1c2VyOjU5OThhYjE1MGM6b3B0aW9uIiwic3ViIjoiYXBpXC9xdWVzdGlvbiIsImlzcyI6Imh0dHBzOlwvXC9iZXRhLWFwaS5vbmVwdWxzZS5jb21cL2FwaVwvcHVsc2VcL3F1ZXN0aW9uXC9jcmVhdGUiLCJpYXQiOjE0NjA2Mjk1ODksImV4cCI6MTQ2MTgzOTMwOSwibmJmIjoxNDYwNjI5NTg5LCJqdGkiOiI3NGVkMGY0MmE0OWU2YWE2ZjA3MWJjY2RlYmVlOGM5ZSIsInJuZCI6OTczMjIyLCJjaGsiOjQyNjY4MDczOTV9.FhVQ28yWEarOOtaFRJQR3qzJinq7qORbs20Z1mRufus"},{"option":{"text":"Yes/No","selected":false},"option_token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJ1c2VyOjU5OThhYjE1MGM6b3B0aW9uIiwic3ViIjoiYXBpXC9xdWVzdGlvbiIsImlzcyI6Imh0dHBzOlwvXC9iZXRhLWFwaS5vbmVwdWxzZS5jb21cL2FwaVwvcHVsc2VcL3F1ZXN0aW9uXC9jcmVhdGUiLCJpYXQiOjE0NjA2Mjk1ODksImV4cCI6MTQ2MTgzOTMwOSwibmJmIjoxNDYwNjI5NTg5LCJqdGkiOiI3NGVkMGY0MmE0OWU2YWE2ZjA3MWJjY2RlYmVlOGM5ZSIsInJuZCI6NzcwNTAzLCJjaGsiOjMyODgyNDQ5MDN9.1klTciNwvZWaep_iNAnLrnlT3wnCxokwpKhaEX3FGBE"},{"option":{"text":"Image","selected":false},"option_token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJ1c2VyOjU5OThhYjE1MGM6b3B0aW9uIiwic3ViIjoiYXBpXC9xdWVzdGlvbiIsImlzcyI6Imh0dHBzOlwvXC9iZXRhLWFwaS5vbmVwdWxzZS5jb21cL2FwaVwvcHVsc2VcL3F1ZXN0aW9uXC9jcmVhdGUiLCJpYXQiOjE0NjA2Mjk1ODksImV4cCI6MTQ2MTgzOTMwOSwibmJmIjoxNDYwNjI5NTg5LCJqdGkiOiI3NGVkMGY0MmE0OWU2YWE2ZjA3MWJjY2RlYmVlOGM5ZSIsInJuZCI6OTUzNTA3LCJjaGsiOjMxOTUyNDEyNzB9.04mlPs6a9ScQzC2FXC-cmEF-l3SxWMii6mTibj8oV2g"},{"option":{"text":"Branching","selected":false},"option_token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJ1c2VyOjU5OThhYjE1MGM6b3B0aW9uIiwic3ViIjoiYXBpXC9xdWVzdGlvbiIsImlzcyI6Imh0dHBzOlwvXC9iZXRhLWFwaS5vbmVwdWxzZS5jb21cL2FwaVwvcHVsc2VcL3F1ZXN0aW9uXC9jcmVhdGUiLCJpYXQiOjE0NjA2Mjk1ODksImV4cCI6MTQ2MTgzOTMwOSwibmJmIjoxNDYwNjI5NTg5LCJqdGkiOiI3NGVkMGY0MmE0OWU2YWE2ZjA3MWJjY2RlYmVlOGM5ZSIsInJuZCI6ODM4OTYzLCJjaGsiOjMxMjg5NjMxMjJ9.1YFGOkwHYSl0VzBPVkR8Pad9BRkM5PrJRtgw_BQM43c"}],"rules":"min:1|max:1"},"answers":[{"data":{"id":{"value":"8Q5XqAPwXBqn","rules":"locked"},"text":{"value":"","rules":"mandatory|min:1|max:100|translate"},"sequence":{"value":"","rules":"mandatory|numeric|min:1|max:8"},"image":{"value":"https://beta-api.onepulse.com/api/image/eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOnsicm9sZSI6WyJpbWFnZSoiXX0sInN1YiI6ImFwaVwvaW1hZ2UiLCJpc3MiOiJodHRwczpcL1wvYmV0YS1hcGkub25lcHVsc2UuY29tXC9hcGlcL3B1bHNlXC9jcmVhdGUiLCJpYXQiOjE0NjA2MjU0NTIsImV4cCI6MTQ2MTgzNTE3MiwibmJmIjoxNDYwNjI1NDUyLCJqdGkiOiI4OWEzZTY5NDcwMmNjNDNjMjVkMTIwNTE3MGVlMzAwNyIsInJuZCI6MzM3NTA3LCJjaGsiOjE4NjcyNzIxMDZ9.HZyn3JlQsXQ2aOOqtR43-VKcCkq0_qeQdV2CoTw92nI","rules":"image_path:8,231,231"}},"data_token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJhbnN3ZXI6cHVsc2U6ZGF0YSIsInN1YiI6ImFwaVwvcHVsc2UiLCJpc3MiOiJodHRwczpcL1wvYmV0YS1hcGkub25lcHVsc2UuY29tXC9hcGlcL3B1bHNlXC9xdWVzdGlvblwvY3JlYXRlIiwiaWF0IjoxNDYwNjI5NTg5LCJleHAiOjE0NjE4MzkzMDksIm5iZiI6MTQ2MDYyOTU4OSwianRpIjoiZTIzMzE2ZTRmZWM4MzFhOWQ2YWVmNDNmOTM5MWM0ZDUiLCJybmQiOjkzMjU2MCwiY2hrIjo1ODkzMjA1Mjl9.Q4OFIzZxWJlwd3h7NLOwLA7Fm1fn7qHRTF7O9PPDgZE"},{"data":{"id":{"value":"","rules":"locked"},"text":{"value":"","rules":"mandatory|min:1|max:100|translate"},"sequence":{"value":"","rules":"mandatory|numeric|min:1|max:8"},"image":{"value":"","rules":"image_path:8,231,231"}},"data_token":""}],"is_shuffle_answers":{"value":"0","rules":"boolean"}},"data_token":""};
    };

    tempAnswerOption = function(){
        return null;//{"data":{"id":{"value":"8Q5XqAPwXBqn","rules":"locked"},"text":{"value":"","rules":"mandatory|min:1|max:100|translate"},"sequence":{"value":"","rules":"mandatory|numeric|min:1|max:8"},"image":{"value":"https://beta-api.onepulse.com/api/image/eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOnsicm9sZSI6WyJpbWFnZSoiXX0sInN1YiI6ImFwaVwvaW1hZ2UiLCJpc3MiOiJodHRwczpcL1wvYmV0YS1hcGkub25lcHVsc2UuY29tXC9hcGlcL3B1bHNlXC9jcmVhdGUiLCJpYXQiOjE0NjA2MjU0NTIsImV4cCI6MTQ2MTgzNTE3MiwibmJmIjoxNDYwNjI1NDUyLCJqdGkiOiI4OWEzZTY5NDcwMmNjNDNjMjVkMTIwNTE3MGVlMzAwNyIsInJuZCI6MzM3NTA3LCJjaGsiOjE4NjcyNzIxMDZ9.HZyn3JlQsXQ2aOOqtR43-VKcCkq0_qeQdV2CoTw92nI","rules":"image_path:8,231,231"}},"data_token":""};
    };

    findFirstQuestion = function(questions) {
        for (i = 0; i < questions.length; i++) {
            question = questions[i];
            if (question.data != undefined && question.data.branch != undefined && question.data.branch.value == 0 &&
                question.data.sequence.value == 1) {
                return question;
            }
        }

        return null;
    };

    filledAnswers = function(answers) {
        result = [];

        if(typeof answers != "undefined") {

            for(i = 0; i < answers.length; i++) {
                answer = answers[i];
                if (answer.data.text.value != "") {
                    result.push(answer);
                }
            }
        }

        return result;
    };

    sortBySequence = function(questions) {
        return questions.sort(function(a, b){
            // By default, questions are sorted from latest to newest.
            return a.data.sequence.value < b.data.sequence.value ? -1 : 1;
        });
    };

    //Sort object array by property
    sortByProperty = function(object, property, direction) {

        if(typeof direction == "undefined") {

            direction = 'desc';
        }

        return object.sort(function(a, b){

            switch(direction) {

                case 'asc':
                    return a.data[property].value < b.data[property].value ? -1 : 1;
                    break;
                case 'desc':
                    return a.data[property].value > b.data[property].value ? -1 : 1;
                    break;
            }
        });
    };

    //Move an array element to beginning of array by property
    unShiftArrayByProperty = function(object, property, propertyValue) {

        for(var i = 0;  i < object.length; i++) {

            if(object[i].data[property].value == propertyValue) {

                var tempValue = angular.copy(object[i]);
                object.splice( i, 1 );
                object.unshift(tempValue);
            }
        }

        return object;
    };

    hasDuplicates = function(array) {

        var sorted_arr = array.slice().sort();

        var duplicatesArray = [];
        for (var i = 0; i < array.length - 1; i++) {
            if (sorted_arr[i + 1] == sorted_arr[i]) {
                duplicatesArray.push(sorted_arr[i]);
            }
        }

        return (duplicatesArray.length > 0);
    };

    searchStringInArray = function(str, strArray) {

        for (var j=0; j<strArray.length; j++) {
            if (strArray[j].match(str)) return true;
        }
        return false;
    };

    //Adds a comma as thousand separator (with optional decimal remover)
    thousandSeparator = function(array, removeAfterDec) {

        for(var index in array) {

            if(removeAfterDec) {

                array[index] = (parseInt(array[index])).toString();
            }

            array[index] = array[index].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }

        if(array.length == 1) {
            return array[0];
        } else {
            return array;
        }
    };

    simpleDate = function(date) {

        pad = function(num) {
            var norm = Math.abs(Math.floor(num));
            return (norm < 10 ? '0' : '') + norm;
        };
        return pad(date.getDate())
        + '/' + pad(date.getMonth()+1)
        + '/' + date.getFullYear();
    };

    prettyDate = function(date, fullNames, withYear) {

        if(fullNames) {

            var dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            var monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];
        } else {

            var dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
            var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
            ];
        }

        pad = function(num) {
            var norm = Math.abs(Math.floor(num));
            return (norm < 10 ? '0' : '') + norm;
        };

        return dayNames[date.getDay()]
            + ', ' + pad(date.getDate())
            + ' ' + monthNames[date.getMonth()]
            + (withYear ? ', ' + date.getFullYear() : '');
    };

    formatDate = function(date, time) {

            tzo = -date.getTimezoneOffset(),
            dif = tzo >= 0 ? '+' : '-',
            pad = function(num) {
                var norm = Math.abs(Math.floor(num));
                return (norm < 10 ? '0' : '') + norm;
            };
        return date.getFullYear()
            + '-' + pad(date.getMonth()+1)
            + '-' + pad(date.getDate())
            + 'T' + pad(time.getHours())
            + ':' + pad(time.getMinutes())
            + ':' + pad(time.getSeconds())
            + dif + pad(tzo / 60)
            + '' + pad(tzo % 60);
    };

    formatDateNoTimeZone = function(date, time) {

        return date.getFullYear()
            + '-' + pad(date.getMonth()+1)
            + '-' + pad(date.getDate())
            + 'T' + pad(time.getHours())
            + ':' + pad(time.getMinutes())
            + ':' + pad(time.getSeconds());
    };

    formatTime = function(date, showSeconds) {

        var pad = function(num) {
            var norm = Math.abs(Math.floor(num));
            return (norm < 10 ? '0' : '') + norm;
        };

        return pad(date.getHours()) + ':' + pad(date.getMinutes()) + (showSeconds?':' + pad(date.getSeconds()):'');
    };

    //Parse 2 date strings and return the difference in day, hours, minutes, etc.
    dateDiff = function (str1, str2) {

        var diff = Date.parse(str2) - Date.parse(str1);

        return isNaN( diff ) ? NaN : {
            diff : diff,
            ms : Math.floor( diff            % 1000 ),
            s  : Math.floor( diff /     1000 %   60 ),
            m  : Math.floor( diff /    60000 %   60 ),
            h  : Math.floor( diff /  3600000 %   24 ),
            d  : Math.floor( diff / 86400000        )
        };
    };

    titleCase = function(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    calculateRatingWidth = function(rating) {

        if(typeof rating != "undefined" && rating != "") {

            var width = $('.stars-inner').css('width');
            width = parseInt(width.replace("px", ""));

            return (width / 100) * ((rating * 2) * 10) + 'px';
        } else {

            return '0px';
        }
    };

    twoDecPlacesNoRounding = function(num) {

        num = num.toString(); //If it's not already a String
        return num.slice(0, (num.indexOf("."))+3); //With 3 exposing the hundredths place
    };

    appendNumberPositionText = function(number) {

        var append = '';

        if(parseInt(number) == 1) {

            append = 'st';
        } else if(parseInt(number) == 2) {

            append = 'nd';
        } else if(parseInt(number) == 3) {

            append = 'rd';
        } else {

            append = 'th';
        }

        return number.toString() + append;
    };

    roundNumbers = function(number,decimals){

        return parseFloat((number).toFixed(decimals))
    };

    roundIfWholeNumber = function(number){

        return (typeof number != "undefined" && number != "" ? (number % 1 != 0 ? number.toFixed(0) : number) : "");
    };

    searchData = function(data,value){

        for(var e=0; e< data.getNumberOfRows(); e++){
            if(data.getValue(e,0) == value){
                return true;
            }
        }

        return false;
    };

    getUserAvatar = function(avatar, demOne, demTwo) {
        
        if(typeof avatar !== "undefined" && avatar !== null && avatar !== "" && avatar.indexOf('fbcdn') === -1 && avatar.indexOf('.png') === -1) {

            if(avatar.indexOf('?width=691') !== -1) {

                return avatar.replace("?width=691", "?width=50");

            } else if(avatar.indexOf('/image/') !== -1) {

                return avatar + '/50x50';

            } else {

                return avatar;
            }
        };

        if (demOne !== '' && demOne !== "undefined" && demOne !== null && demTwo !== '' && demTwo !== "undefined" && demTwo !== null) {
            demOne.toString();
            demTwo.toString();

            var young = ['16','17','18','19', '20', '21'];
            var youngTwo = ['22', '23', '24', '25'];
            var adult = ['26','27', '28', '29', '30', '31', '32', '33', '34']
            var middleAge = ['35','36', '37', '38', '39', '40', '41', '42', '43', '44'];

            function contains(string, pattern) {
                var value = 0;
                pattern.forEach(function(partOf){
                value = value + string.includes(partOf);
                
                });
                return (value > 0)
            }
    
            // 16-21
            if (contains(demOne, young) || contains(demTwo, young)) {
                var picId = Math.floor((Math.random() * 4) + 1);

                if (demOne === 'Male' || demTwo === 'Male') {
                    return "/assets/img/responses/16-21/" + picId + "m.png";
                }

                if (demOne === 'Female' || demTwo === 'Female') {
                    return "/assets/img/responses/16-21/" + picId + "f.png";
                }

                return "/assets/img/responses/16-21/" + picId + "m.png";
            } 

            // 22-25
            if (contains(demOne, youngTwo) || contains(demTwo, youngTwo)) {
                var picId = Math.floor((Math.random() * 4) + 1);

                if (demOne === 'Male' || demTwo === 'Male') {
                    return "/assets/img/responses/22-25/" + picId + "m.png";
                }

                if (demOne === 'Female' || demTwo === 'Female') {
                    return "/assets/img/responses/22-25/" + picId + "f.png";
                }

                return "/assets/img/responses/22-25/" + picId + "m.png";
            } 

            // 26-34
            if (contains(demOne, adult) || contains(demTwo, adult)) {
                var picId = Math.floor((Math.random() * 5) + 1);

                if (demOne === 'Male' || demTwo === 'Male') {
                    return "/assets/img/responses/26-34/" + picId + "m.png";
                }

                if (demOne === 'Female' || demTwo === 'Female') {
                    return "/assets/img/responses/26-34/" + picId + "f.png";
                }

                return "/assets/img/responses/26-34/" + picId + "m.png";
            }

            // 35-44
            if (contains(demOne, middleAge) || contains(demTwo, middleAge)) {
                var picId = Math.floor((Math.random() * 5) + 1);

                if (demOne === 'Male' || demTwo === 'Male') {
                    return "/assets/img/responses/35-44/" + picId + "m.png";
                }

                if (demOne === 'Female' || demTwo === 'Female') {
                    return "/assets/img/responses/35-44/" + picId + "f.png";
                }

                return "/assets/img/responses/35-44/" + picId + "m.png";
            } 

            if (demOne === 'Male' || demTwo === 'Male') {
                var picId = Math.floor((Math.random() * 5) + 1);
                return "/assets/img/responses/45/" + picId + "m.png";
            }

            if (demOne === 'Female' || demTwo === 'Female') {
                var picId = Math.floor((Math.random() * 5) + 1);
                return "/assets/img/responses/45/" + picId + "f.png";
            }

            return "/assets/img/responses/35-44/3m.png";

        }

        return "/assets/img/responses/35-44/3m.png";
    };

    diffInDays = function(firstDate, secondDate) {

        var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds

        return Math.round(Math.abs((firstDate.getTime() - secondDate.getTime())/(oneDay)));
    };

    extractSlug = function(url) {

        return (url.substr(url.lastIndexOf('/') + 1));
    };

    randomString = function(length) {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for(var i = 0; i < length; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    };

    shadeColor = function(color, percent) {

        var f=parseInt(color.slice(1),16),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=f>>16,G=f>>8&0x00FF,B=f&0x0000FF;
        return "#"+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1);
    };

    extend = function(obj, src) {

        Object.keys(src).forEach(function(key) { obj[key] = src[key]; });
        return obj;
    };

    //Compare 2 arrays
    findOne = function (haystack, arr) {

        return arr.some(function (v) {
            return haystack.indexOf(v) >= 0;
        });
    };

    noSpace = function (value) {

        return (!value) ? '' : value.replace(/ /g, '');
    };

    /**
     * Determine the mobile operating system.
     * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
     *
     * @returns {String}
     */
    getMobileOperatingSystem = function() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
            return "Android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }

        return "unknown";
    };

    getViewportDimensions = function() {

        var dimensions = {};

        dimensions.width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        dimensions.height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

        return dimensions;
    };

    determineDeviceType = function(dimensions) {

        var deviceType = null;

        if(parseInt(dimensions.width) < 768) {

            deviceType = 'mobile';
        } else {

            deviceType = 'desktop';
        }

        return deviceType;
    };

    determineBrowser = function() {

        var ua=navigator.userAgent,tem,M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if(/trident/i.test(M[1])){
            tem=/\brv[ :]+(\d+)/g.exec(ua) || [];
            return {name:'IE',version:(tem[1]||'')};
        }
        if(M[1]==='Chrome'){
            tem=ua.match(/\bOPR|Edge\/(\d+)/)
            if(tem!=null)   {return {name:'Opera', version:tem[1]};}
        }
        M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
        if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}
        return {
            name: M[0],
            version: M[1]
        };
    };

    roughSizeOfObject = function( object ) {

        var objectList = [];
        var stack = [ object ];
        var bytes = 0;

        while ( stack.length ) {
            var value = stack.pop();

            if ( typeof value === 'boolean' ) {
                bytes += 4;
            }
            else if ( typeof value === 'string' ) {
                bytes += value.length * 2;
            }
            else if ( typeof value === 'number' ) {
                bytes += 8;
            }
            else if
            (
                typeof value === 'object'
                && objectList.indexOf( value ) === -1
            )
            {
                objectList.push( value );

                for( var i in value ) {
                    stack.push( value[ i ] );
                }
            }
        }
        return bytes;
    };

    scorePassword = function(pass) {

        var score = 0;
        if (!pass)
            return score;

        // award every unique letter until 5 repetitions
        var letters = new Object();
        for (var i=0; i<pass.length; i++) {
            letters[pass[i]] = (letters[pass[i]] || 0) + 1;
            score += 5.0 / letters[pass[i]];
        }

        // bonus points for mixing it up
        var variations = {
            digits: /\d/.test(pass),
            lower: /[a-z]/.test(pass),
            upper: /[A-Z]/.test(pass),
            nonWords: /\W/.test(pass)
        };

        variationCount = 0;
        for (var check in variations) {
            variationCount += (variations[check] == true) ? 1 : 0;
        }
        score += (variationCount - 1) * 10;

        return parseInt(score);
    };

    checkPassStrength = function(pass) {

        var score = scorePassword(pass);
        if (score > 70)
            return "strong";
        if (score > 50)
            return "good";
        if (score >= 0)
            return "weak";

        return "";
    };

    goToByScroll = function(id){
        $('html,body').animate({scrollTop: $("#"+id).offset().top},'slow');
    };

    slugify = function(string) {

        if(typeof string != "undefined" && string != null) {

            return string
                .toLowerCase()
                .replace(/ /g,'-')
                .replace(/[^\w-]+/g,'');
        }
    };

    sortNumber = function(a,b) {
        return a - b;
    }

    listCookies = function() {

        var theCookies = document.cookie.split(';');
        var aString = '';
        for (var i = 1 ; i <= theCookies.length; i++) {
            aString += i + ' ' + theCookies[i-1] + "\n";
        }
        return aString;
    };

    deleteCookies = function() {

        document.cookie.split(";").forEach(
            function(c) {
                document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
            }
        );
    };

    envRedirect = function() {

        var hostname = window.location.href;

        if(hostname.indexOf('uk.onepulse.com') != -1 || hostname.indexOf('us.onepulse.com') != -1) {

            $(document).ready(function() {

                window.location.replace("https://www.onepulse.com" + window.location.pathname);
            });
        } else if(hostname.indexOf('client.onepulse.com') != -1 && window.location.pathname == "/") {

            $(document).ready(function() {

                window.location.replace("https://client.onepulse.com/login");
            });
        }
    };

    lightenDarkenColor = function(color, percent) {

        var f=parseInt(color.slice(1),16),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=f>>16,G=f>>8&0x00FF,B=f&0x0000FF;
        return "#"+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1);
    };

    outsideOfPulseQuietTimes = function(regions, quietTimes, pulseStartHour) {

        var regionsOutsideOfPulseQuietTimes = [];
        var quietTimeStart = 23;
        var quietTimeEnd = 6;
        var quietTimeOffsets = [];

        for(var i = 0; i < regions.length; i++) {

            if(typeof quietTimes[regions[i]] !== "undefined") {

                quietTimeOffsets.push({"code": regions[i], "offset": quietTimes[regions[i]].UTC_OFFSETS});

                quietTimeStart = (quietTimes[regions[i]].START < quietTimeStart ? quietTimes[regions[i]].START : quietTimeStart);
                quietTimeEnd = (quietTimes[regions[i]].END > quietTimeEnd ? quietTimes[regions[i]].END : quietTimeEnd);
            }
        }

        var d = new Date;
        d.setHours(pulseStartHour);
        var utc = d.getTime() - (d.getTimezoneOffset() * 60000);

        for(var j = 0; j < quietTimeOffsets.length; j++) {

            var nd = new Date(utc + (3600000 * parseFloat(quietTimeOffsets[j].offset))).getHours();

            if(nd >= quietTimeStart || nd <= quietTimeEnd) {

                regionsOutsideOfPulseQuietTimes.push(quietTimeOffsets[j]);
            }

            // console.log(quietTimeOffsets[j]);
            // console.log("quietTimeStart: " + quietTimeStart);
            // console.log("quietTimeEnd: " + quietTimeEnd);
            // console.log("pulseStart time in region: " + nd);
            // console.log("pulseStartHour: " + pulseStartHour);
        }

        return regionsOutsideOfPulseQuietTimes;
    };

    divideEvenly = function(total, parts) {

        var partCounter = 0;
        var partArray = [];

        for(var l = 1; l <= total; l++) {

            if(typeof partArray[partCounter] === "undefined") {

                partArray[partCounter] = 1;
            } else {

                partArray[partCounter]++;
            }

            if(partCounter === parts - 1) {

                partCounter = 0;
            } else {

                partCounter++;
            }
        }

        return partArray;
    };

    multiply = function(rgb1, rgb2){
        rgb1.b = Math.floor(rgb1.b * rgb2.b / 255);
        rgb1.g = Math.floor(rgb1.g * rgb2.g / 255);
        rgb1.r = Math.floor(rgb1.r * rgb2.r / 255);
        return tinycolor('rgb ' + rgb1.r + ' ' + rgb1.g + ' ' + rgb1.b);
    };

    getColorObject = function(value, name) {
        var c = tinycolor(value);
        return {
            name: name,
            hex: c.toHexString(),
            darkContrast: c.isLight()
        };
    };

    // Function to calculate all colors from base
    // These colors were determined by finding all
    // HSL values for a google palette, calculating
    // the difference in H, S, and L per color
    // change individually, and then applying these
    // here.
    computeColors = function(hex)
    {
        // Return array of color objects.
        var baseLight = tinycolor('#ffffff');
        var baseDark = multiply(tinycolor(hex).toRgb(), tinycolor(hex).toRgb());
        var baseTriad = tinycolor(hex).tetrad();

        return [
            getColorObject(tinycolor.mix(baseLight, hex, 12), '50'),
            getColorObject(tinycolor.mix(baseLight, hex, 30), '100'),
            getColorObject(tinycolor.mix(baseLight, hex, 50), '200'),
            getColorObject(tinycolor.mix(baseLight, hex, 70), '300'),
            getColorObject(tinycolor.mix(baseLight, hex, 85), '400'),
            getColorObject(tinycolor.mix(baseLight, hex, 100), '500'),
            getColorObject(tinycolor.mix(baseDark, hex, 87), '600'),
            getColorObject(tinycolor.mix(baseDark, hex, 70), '700'),
            getColorObject(tinycolor.mix(baseDark, hex, 54), '800'),
            getColorObject(tinycolor.mix(baseDark, hex, 25), '900'),
            getColorObject(tinycolor.mix(baseDark, baseTriad[4], 15).saturate(80).lighten(65), 'A100'),
            getColorObject(tinycolor.mix(baseDark, baseTriad[4], 15).saturate(80).lighten(55), 'A200'),
            getColorObject(tinycolor.mix(baseDark, baseTriad[4], 15).saturate(100).lighten(45), 'A400'),
            getColorObject(tinycolor.mix(baseDark, baseTriad[4], 15).saturate(100).lighten(40), 'A700')
        ];

            // return [
            //     getColorObject(tinycolor(hex).lighten(52), '50'),
            //     getColorObject(tinycolor(hex).lighten(37), '100'),
            //     getColorObject(tinycolor(hex).lighten(26), '200'),
            //     getColorObject(tinycolor(hex).lighten(12), '300'),
            //     getColorObject(tinycolor(hex).lighten(6), '400'),
            //     getColorObject(tinycolor(hex), '500'),
            //     getColorObject(tinycolor(hex).darken(6), '600'),
            //     getColorObject(tinycolor(hex).darken(12), '700'),
            //     getColorObject(tinycolor(hex).darken(18), '800'),
            //     getColorObject(tinycolor(hex).darken(24), '900'),
            //     getColorObject(tinycolor(hex).lighten(50).saturate(30), 'A100'),
            //     getColorObject(tinycolor(hex).lighten(30).saturate(30), 'A200'),
            //     getColorObject(tinycolor(hex).lighten(10).saturate(15), 'A400'),
            //     getColorObject(tinycolor(hex).lighten(5).saturate(5), 'A700')
            // ];

    };

    createAjsPaletteForUse = function (colors) {
        var exportable = {};
        var darkContrast = [0, 0, 0, 0.87];
        var lightContrast = [255, 255, 255, 0.87];
        angular.forEach(colors, function (value, key) {
            if(value.darkContrast){
                contrastArray = darkContrast;
            }else{
                contrastArray = lightContrast;
            }
            var rgb = tinycolor(value.hex).toRgb();
            exportable[value.name] = {
                contrast: contrastArray,
                hex: value.hex,
                value: [rgb.r, rgb.g, rgb.b]
            };
        });
        return exportable;
    };

    String.prototype.capitalize = function() {
        return this.charAt(0).toUpperCase() + this.slice(1);
    };

    //Save json object as file. Usage: console.save(obj, ['filename'])
    (function(console){

        console.save = function(data, filename){

            if(!data) {
                console.error('Console.save: No data')
                return;
            }

            if(!filename) filename = 'console.json'

            if(typeof data === "object"){
                data = JSON.stringify(data, undefined, 4)
            }

            var blob = new Blob([data], {type: 'text/json'}),
                e    = document.createEvent('MouseEvents'),
                a    = document.createElement('a')

            a.download = filename
            a.href = window.URL.createObjectURL(blob)
            a.dataset.downloadurl =  ['text/json', a.download, a.href].join(':')
            e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
            a.dispatchEvent(e)
        }
    })(console)

})();
